// Composer for Ballpark question packs. Each pack lives in its own file under
// ballparkPacks/ so the individual lists stay focused and easy to review.
import { general } from "./ballparkPacks/general"
import { kids } from "./ballparkPacks/kids"
import { history } from "./ballparkPacks/history"
import { science } from "./ballparkPacks/science"
import { sports } from "./ballparkPacks/sports"
import { popculture } from "./ballparkPacks/popculture"
import { geography } from "./ballparkPacks/geography"
import { presidents } from "./ballparkPacks/presidents"
import { food } from "./ballparkPacks/food"
import { art } from "./ballparkPacks/art"
import { tech_space } from "./ballparkPacks/tech_space"
import { lds_history } from "./ballparkPacks/lds_history"
import { lds_scriptures } from "./ballparkPacks/lds_scriptures"

export const PACKS = [
  { id: "general", name: "Family favorites", blurb: "All-ages trivia: animals, space, geography", questions: general },
  { id: "kids", name: "Kids' corner", blurb: "Easier numbers for younger players", questions: kids },
  { id: "history", name: "History & records", blurb: "Dates, records, and inventions", questions: history },
  { id: "science", name: "Science & nature", blurb: "The body, space, animals, and physics", questions: science },
  { id: "sports", name: "Sports & games", blurb: "Rules, records, scores, and board games", questions: sports },
  { id: "popculture", name: "Pop culture", blurb: "Movies, music, TV, and video games", questions: popculture },
  { id: "geography", name: "Geography & places", blurb: "Populations, dimensions, and heights", questions: geography },
  { id: "presidents", name: "Presidents & politics", blurb: "U.S. history, elections, and laws", questions: presidents },
  { id: "food", name: "Food & drink", blurb: "Kitchen conversions, calories, and history", questions: food },
  { id: "art", name: "Literature & art", blurb: "Word counts, painting dates, and books", questions: art },
  { id: "tech_space", name: "Tech & space", blurb: "Computing, orbital periods, and constants", questions: tech_space },
  { id: "lds_history", name: "LDS Church history", blurb: "Pioneers, temple details, and restoration", questions: lds_history },
  { id: "lds_scriptures", name: "LDS Scriptures", blurb: "Chapters, verses, and scripture timelines", questions: lds_scriptures },
]

export function getQuestions(packIds) {
  return PACKS.filter((p) => packIds.includes(p.id)).flatMap(
    (p) => p.questions
  )
}
